// extracted by mini-css-extract-plugin
module.exports = {"Container":"Sections_Container__ojbZj","Content":"Sections_Content__C__Bt"};